import React, { useState, useEffect, useCallback, useReducer } from 'react'
import { Helmet } from 'react-helmet'
import LWCLayout from '../layouts/LWCLayout'
import FormUtils from '../utils/FormUtils'
import DatePicker from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import ReCAPTCHA from "react-google-recaptcha";

const TableauTemplate = data => {
    const { pageContext: { slug } } = data

    const [countryList, setCountryList] = useState();
    const [showModal, setShowModal] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [apiMessage, setApiMessage] = useState(false);
    const [isLoggedUser, setloggedUser] = useState();
    const [recaptchaToken, setRecaptchaToken] = useState('')
    const recaptchaRef = React.createRef()
    const [recaptchaTokenFormHandler, setRecaptchaTokenFormHandler] = useState('')
    const recaptchaRefFormHandler = React.createRef()
    const [uploadedImage, setUploadedImage] = useState(null)
    let filesToUpload = [];

    useEffect(() => {
        const loggedUser = localStorage.getItem('tbid');
        if (!loggedUser) {
            const origin = window.location.origin;
            const pathName = 'sessions/users/new?type=tbidlogin';
            window.location = `${origin}/${pathName}`;
        } else {
            setloggedUser(loggedUser)
        }
    }, []);

    const inputReducer = (state, action) => {
        switch (action?.type) {
            case "CLEARSTATE":
                return {};
            case "UPDATESTATE":
                return {
                    ...state,
                    Upload_Logo__c: [...state['Upload_Logo__c'], ...action.value]
                }
            default:
                return { ...state, [action.id]: action.value };
        }
    }

    const [inputValues, dispatchFieldChanges] = useReducer(inputReducer, {});
    const [fieldErrors, dispatchFieldErrorsChanges] = useReducer(inputReducer, {});

    useEffect(() => {
        getListOfCountries();
        asyncPrepareFields();
    }, [])

    useEffect(() => {
        if (countryList?.length > 0) {
            setComboOptions();
        }
    }, [countryList])

    useEffect(() => {
        if (inputValues['Country__c']) {
            const selectedCountry = countryList?.filter(country => country.label === inputValues['Country__c']);
            dispatchFieldChanges({ id: 'termsAndCondition', value: selectedCountry[0] });
            dispatchFieldErrorsChanges({ id: 'legalText', value: null });
            dispatchFieldChanges({ id: 'legalText', value: null });
            asyncPrepareFields();
        }
    }, [inputValues['Country__c']])

    const handleInputFileOnChange = (e => {
        e.preventDefault()
        const val = e.target.files
        const inputId = e.target.id

        for (let i = 0; i < val.length; i++) {
            let myFile = val[i];
            let myFileID = "FID" + (1000 + Math.random() * 9000).toFixed(0);

            filesToUpload.push({
                file: myFile,
                FID: myFileID
            });
        };
        if (inputValues['Upload_Logo__c']?.length > 0) {
            dispatchFieldChanges({ id: inputId, value: filesToUpload, type: 'UPDATESTATE' });
        } else {
            dispatchFieldChanges({ id: inputId, value: filesToUpload });
        }
        e.target.value = null;
    });

    const removeFile = (fileId) => {
        for (let i = 0; i < inputValues['Upload_Logo__c']?.length; i++) {
            if (inputValues['Upload_Logo__c'][i].FID === fileId)
                inputValues['Upload_Logo__c'].splice(i, 1);
        }
        dispatchFieldChanges({ id: 'Upload_Logo__c', value: inputValues['Upload_Logo__c'] });
    }

    const showFileInputValidation = (msg) => {
        let fileParentElement = document.querySelector('#Upload_Logo__c').closest('.slds-form-element')

        if (msg) {
            fileParentElement.classList.add('slds-has-error')
            fileParentElement.querySelector('.slds-form-element__help').innerHTML = msg
        }
        else {
            fileParentElement.classList.remove('slds-has-error')
            fileParentElement.querySelector('.slds-form-element__help').innerHTML = ''
        }
    }

    const handleRecaptchaFail = () => {
        setRecaptchaToken('')
    }

    const handleRecaptcha = (value) => {
        setRecaptchaToken(value)
    }

    const handleRecaptchaFailFormHandler = () => {
        setRecaptchaTokenFormHandler('')
    }

    const handleRecaptchaFormHandler = (value) => {
        setRecaptchaTokenFormHandler(value)
    }


    const onChangeDate = (inputId, date, maxDateId = '') => {
        if (date) {
            var newDate = new Date(date);
            var now_utc = Date.UTC(newDate.getUTCFullYear(), newDate.getUTCMonth(),
                newDate.getUTCDate(), newDate.getUTCHours(),
                newDate.getUTCMinutes(), newDate.getUTCSeconds());

            const isoDate = new Date(now_utc)
            if (isoDate) {
                dispatchFieldChanges({ id: inputId, value: isoDate });
            }

            if (maxDateId) {
                const maxdateString = new Date(date);
                const maxDate = new Date(maxdateString.setMonth(maxdateString.getMonth() + 8));
                dispatchFieldChanges({ id: maxDateId, value: maxDate });
            }
        } else {
            dispatchFieldChanges({ id: inputId, value: '' });
        }
    }

    const handleSubmitForm = async (e) => {
        e.preventDefault();
        const hasAnyFormErrors = validateFields();
        let previewErrorMsg = hasAnyFormErrors ? 'Please review the required fields before submitting the form.' : null;
        dispatchFieldErrorsChanges({ id: 'previewErrors', value: previewErrorMsg });

        let uploadErrorCode = null
        let uploadErrorMessage = null
        let uploadedImageName = uploadedImage


        if (!hasAnyFormErrors) {
            setLoading(true)
            setShowModal(true);

            //File upload to S3 ------ START
            // Set the recaptchaRef object here because it lose the reference during the "fetch"
            const recaptchaObj = recaptchaRef.current


            const input = inputValues['Upload_Logo__c']
            const instructorURL = inputValues['Instructor_Academic_Profile_Link__c'] ? inputValues['Instructor_Academic_Profile_Link__c'].trim() : inputValues['Instructor_Academic_Profile_Link__c']
            if (!uploadedImage && input?.length > 0) {
                // Upload image to S3 with our API
                const data = new FormData()
                for (let i = 0; i < input.length; i++) {
                    data.append("file", input[i].file);
                }

                const uploaderOptions = {
                    method: 'POST',
                    headers: { "g-captcha-response": recaptchaToken + "###;v2" },
                    body: data
                }

                // Upload Image using the custom S3_Image_Uploader API
                await fetch(process.env.GATSBY_IMAGE_UPLOADER_ENDPOINT, uploaderOptions).then((res) => res.json()).then((response) => {

                    if (response.status === 'success') {
                        uploadedImageName = response.data.imageName
                        setUploadedImage(uploadedImageName)

                    } else {
                        uploadedImageName = null
                        uploadErrorCode = response.errorCode
                        const maxSize = response.maxSize ? response.maxSize / 1024 : '';
                        uploadErrorMessage = (uploadErrorCode == 0 || uploadErrorCode == 5) ? `File is too large (${maxSize}kb max)` : response.errorMessage;
                        setLoading(false);
                        setApiMessage({ 'status': 'error' });
                        showFileInputValidation(uploadErrorMessage)
                    }

                }).catch((error) => {

                    setLoading(false);
                    uploadErrorMessage = `Can't connect to the endpoint. ${error}`
                    setLoading(false);
                    setApiMessage({ 'status': 'error' });
                    showFileInputValidation(uploadErrorMessage)
                })

            }

            if (!uploadedImageName && !instructorURL) {
                setLoading(false)
                setShowModal(false)
                return
            }

            //File upload to S3 ------ END

            let studentLicenseObj = {};
            let additionStudLicenseObj = {};
            let additionStudLicenseOtherObj = {};
            let tableauCloudSiteObj = {};
            let labLicenseObj = {};
            let consentValue = '';
            let optInValue = '';
            let img1, img2, img3 = ''


            if (inputValues['termsAndCondition']?.showMarketingText) {
                consentValue = 'Explicit';
                optInValue = !!inputValues['Privacy_Consent__c'];
            } else {
                consentValue = 'Implied';
                optInValue = true;
            }

            let splitImgs = uploadedImageName ? uploadedImageName.split(';') : []
            img1 = splitImgs[0] ? splitImgs[0] : img1;
            img2 = splitImgs[1] ? splitImgs[1] : img2;
            img3 = splitImgs[2] ? splitImgs[2] : img3;


            let formHandlerBody = {
                handlerName: 'academic_form_handler',
                First_Name__c: inputValues['First_Name__c'],
                Last_Name__c: inputValues['Last_Name__c'],
                Institute_Name__c: inputValues['Institute_Name__c'],
                Institute_Email__c: inputValues['Institute_Email__c'],
                Country__c: inputValues['Country__c'],
                State__c: inputValues['State__c'] || inputValues['Canada_State__C'],
                Course_Level__c: inputValues['Course_Level__c'],
                Faculty_Department__c: inputValues['Faculty_Department__c'],
                Other_Faculty_Department__c: inputValues['otherFacultyDept'],
                Instructor_Academic_Profile_Link__c: inputValues['Instructor_Academic_Profile_Link__c'],
                Image1_URL__c: img1,
                Image2_URL__c: img2,
                Image3_URL__c: img3,
                Individual_License_Purpose__c: inputValues['Individual_License_Purpose__c'],
                Need_Student_License__c: !!inputValues['studentLicense'],
                additionStudLicense: !!inputValues['additionStudLicense'],
                additionStudLicensenext: !!inputValues['additionStudLicensenext'],
                Need_Tableau_Cloud_Site__c: !!inputValues['tableauCloudSite'],
                Need_Lab_License__c: !!inputValues['labLicense'],
                TBID__c: isLoggedUser,
                Privacy_Statement__c: true,
                Opt_In_Check__c: optInValue,
                Consent__c: consentValue
            }

            if (inputValues['studentLicense']) {
                studentLicenseObj = {
                    Student_License_Course_Level__c: inputValues['Student_License_Course_Level__c'],
                    Student_License_Faculty_Department__c: inputValues['Student_License_Faculty_Department__c'],
                    Other_Student_Faculty_Department__c: inputValues['studOtherFacultyDept'],
                    Student_License_Course_Title__c: inputValues['Student_License_Course_Title__c'],
                    Number_of_Student_License_Needed__c: parseInt(inputValues['Number_of_Student_License_Needed__c']),
                    Student_License_Course_Start_Date__c: FormUtils.trimDateTime(inputValues['Student_License_Course_Start_Date__c']),
                    Student_License_Course_End_Date__c: FormUtils.trimDateTime(inputValues['Student_License_Course_End_Date__c'])
                }
            }

            if (inputValues['additionStudLicense']) {
                additionStudLicenseObj = {
                    Additional_Student_License1_Course_Level__c: inputValues['Additional_Student_License1_Course_Level__c'],
                    Additional_License_1_Faculty_Department__c: inputValues['Additional_License_1_Faculty_Department__c'],
                    Other_Faculty_Department_1__c: inputValues['addiOtherFacultyDept'],
                    Additional_License_1_Course_Title__c: inputValues['Additional_License_1_Course_Title__c'],
                    Additional_Student_License_1_Needed__c: parseInt(inputValues['Additional_Student_License_1_Needed__c']),
                    Additional_License_1_Course_Start_Date__c: FormUtils.trimDateTime(inputValues['Additional_License_1_Course_Start_Date__c']),
                    Additional_License_1_Course_End_Date__c: FormUtils.trimDateTime(inputValues['Additional_License_1_Course_End_Date__c'])
                }
            }

            if (inputValues['additionStudLicensenext']) {
                additionStudLicenseOtherObj = {
                    Additional_License_2_Course_Level__c: inputValues['Additional_License_2_Course_Level__c'],
                    Additional_License_2_Faculty_Department__c: inputValues['Additional_License_2_Faculty_Department__c'],
                    Other_Faculty_Department_2__c: inputValues['addi2OtherFacultyDept'],
                    Additional_License_2_Course_Title__c: inputValues['Additional_License_2_Course_Title__c'],
                    Additional_Student_License_2_Needed__c: parseInt(inputValues['Additional_Student_License_2_Needed__c']),
                    Additional_License_2_Course_Start_Date__c: FormUtils.trimDateTime(inputValues['Additional_License_2_Course_Start_Date__c']),
                    Additional_License_2_Course_End_Date__c: FormUtils.trimDateTime(inputValues['Additional_License_2_Course_End_Date__c'])
                }
            }

            if (inputValues['tableauCloudSite']) {
                tableauCloudSiteObj = {
                    Cloud_Site_License_Needed_By_Date__c: FormUtils.trimDateTime(inputValues['Cloud_Site_License_Needed_By_Date__c'])
                }
            }

            if (inputValues['labLicense']) {
                labLicenseObj = {
                    Number_of_Lab_Licenses__c: parseInt(inputValues['Number_of_Lab_Licenses__c']),
                    Lab_License_Needed_By_Date__c: FormUtils.trimDateTime(inputValues['Lab_License_Needed_By_Date__c'])
                }
            }
            let allFormRequest = { ...formHandlerBody, ...studentLicenseObj, ...additionStudLicenseObj, ...additionStudLicenseOtherObj, ...tableauCloudSiteObj, ...labLicenseObj }
            setLoading(true);

            fetch(process.env.GATSBY_TBC_ENDPOINT, {
                method: 'POST',
                mode: 'cors',
                referrerPolicy: 'origin-when-cross-origin',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Captcha-Response': recaptchaTokenFormHandler,
                    'Access-Control-Allow-Headers': 'origin, X-Custom-Header',
                    'Access-Control-Allow-Method': 'POST',
                    'Access-Control-Allow-Origin': '*'
                },
                body: JSON.stringify(allFormRequest)

            }).then(res => res.json()).then(res => {
                setLoading(false);
                setApiMessage(res);
            });

        }
    }

    const getListOfCountries = useCallback(() => {
        fetch(process.env.GATSBY_COUNTRY_LIST_ENDPOINT).then(r => r.json()).then(data => {
            const excludedCountries = ['Russia', 'Belarus', 'Ukraine'];
            const filteredCountryList = data.map(countryLabel => {
                // console.log('Excluded Country', countryLabel.label, excludedCountries.indexOf(countryLabel.label))
                if (excludedCountries.indexOf(countryLabel.label) <= -1) {
                    return countryLabel;
                }
            }).filter(undefinedValue => undefinedValue !== undefined);
            setCountryList(filteredCountryList);
        })
    }, [])

    const setComboOptions = () => {
        customElements.whenDefined("tds-combobox").then(() => {
            const dropdownsOptions = { ...getDropdownsOptions() }

            if (countryList?.length > 0) {
                dropdownsOptions['Country__c'] = countryList.map(item => item.label);
            }

            Object.keys(dropdownsOptions).forEach(combo => {
                const comboEl = document.querySelector(`#${combo}`);

                if (comboEl && comboEl.dataset && !Object.hasOwnProperty.call(comboEl.dataset, 'alreadySetOptions')) {
                    comboEl.dataset.alreadySetOptions = true;
                    comboEl.options = dropdownsOptions[combo].map(item => { return { label: item, value: item } });
                }
            })
        })

    }

    // --- CUSTOM METHODS ---
    const validateFields = () => {
        const fieldsToValidate = document.querySelectorAll('[data-validate]');
        const fileUploadField = document.querySelector('#Upload_Logo__c')

        let valid = false;
        let dateError = false;

        fieldsToValidate.forEach(field => {
            let message = ''
            let hasAnyError = false;

            if (field.tagName === 'TDS-INPUT' && field.shadowRoot) {
                const value = field.shadowRoot.querySelector("input").value;

                if (field.type === "text" || field.type === "email" || field.type === "checkbox") {
                    if (value === '' && field.dataset.validate === 'firstName') {
                        message = 'Please enter first name.'
                        hasAnyError = true
                    }
                    else if (value !== '' && field.dataset.validate === 'firstName' && FormUtils.isLimitCharacters(value, 127)) {
                        message = 'Please enter first name. It must be less than 128 characters.'
                        hasAnyError = true
                    }
                    else if (value === '' && field.dataset.validate === 'lastName') {
                        message = 'Please enter last name.'
                        hasAnyError = true
                    }
                    else if (value !== '' && field.dataset.validate === 'lastName' && FormUtils.isLimitCharacters(value, 127)) {
                        message = 'Please enter last name. It must be less than 128 characters.'
                        hasAnyError = true
                    }
                    else if (value === '' && field.id === 'Institute_Name__c') {
                        message = 'Please enter the name of institution.'
                        hasAnyError = true
                    }
                    else if (value !== '' && field.dataset.validate === 'instituteName' && FormUtils.isLimitCharacters(value, 255)) {
                        message = 'Please enter the name of institution. It must be less than 256 characters.'
                        hasAnyError = true
                    }
                    else if (value === '' && field.dataset.validate === 'email' || value !== '' && field.dataset.validate === 'email' && !FormUtils.isValidEmail(value)) {
                        message = 'Please enter valid school-issued email. example@yourdomain.com'
                        hasAnyError = true
                    }
                    else if (value === '' && field.dataset.validate === 'confirmemail' || value !== '' && field.dataset.validate === 'confirmemail' && document.getElementById('Institute_Email__c').value !== value) {
                        message = 'Please re-enter same school-issued email. example@yourdomain.com'
                        hasAnyError = true
                    }

                    else if (value === '' && field.dataset.validate === 'url' || value !== '' && field.dataset.validate === 'url' && !FormUtils.isValidUrl(value)) {
                        //Instructor URL can be empty when the file uploads have been provided
                        if (field.id === 'Instructor_Academic_Profile_Link__c') {
                            if (inputValues['Upload_Logo__c']?.length == 0) {
                                message = 'URL not valid. Please include a valid URL of your profile or upload appropriate verification document(s)'
                                hasAnyError = true
                            }
                        }
                        else {
                            message = 'Url not valid'
                            hasAnyError = true
                        }
                    }
                    else if (inputValues['studentLicense'] && value === '' && field.dataset.validate === 'studCourseTitle') {
                        message = 'Please enter course title.'
                        hasAnyError = true
                    }
                    else if (inputValues['studentLicense'] && value !== '' && field.dataset.validate === 'studCourseTitle' && FormUtils.isLimitCharacters(value, 255)) {
                        message = 'Please enter course title. It must be less than 256 characters.'
                        hasAnyError = true
                    }
                    else if (inputValues['Faculty_Department__c'] === "Other" && !inputValues['otherFacultyDept'] && field.dataset.validate === 'otherFacultyDept') {
                        message = 'Enter Other Faculty Department'
                        hasAnyError = true
                    }
                    else if (inputValues['Faculty_Department__c'] === "Other" && inputValues['otherFacultyDept'] && field.dataset.validate === 'otherFacultyDept' && FormUtils.isLimitCharacters(inputValues['otherFacultyDept'], 255)) {
                        message = 'Enter Other Faculty Department. It must be less than 256 characters.'
                        hasAnyError = true
                    }
                    else if (inputValues['Student_License_Faculty_Department__c'] === "Other" && !inputValues['studOtherFacultyDept'] && field.dataset.validate === 'studOtherFacultyDept') {
                        message = 'Enter Student Other Faculty Department'
                        hasAnyError = true
                    }
                    else if (inputValues['Student_License_Faculty_Department__c'] === "Other" && inputValues['studOtherFacultyDept'] && field.dataset.validate === 'studOtherFacultyDept' && FormUtils.isLimitCharacters(inputValues['studOtherFacultyDept'], 255)) {
                        message = 'Enter Other Faculty Department. It must be less than 256 characters.'
                        hasAnyError = true
                    }
                    else if (inputValues['Additional_License_1_Faculty_Department__c'] === "Other" && !inputValues['addiOtherFacultyDept'] && field.dataset.validate === 'addiOtherFacultyDept') {
                        message = 'Enter Additional Other Faculty Department'
                        hasAnyError = true
                    }
                    else if (inputValues['Additional_License_1_Faculty_Department__c'] === "Other" && inputValues['addiOtherFacultyDept'] && field.dataset.validate === 'addiOtherFacultyDept' && FormUtils.isLimitCharacters(inputValues['addiOtherFacultyDept'], 255)) {
                        message = 'Enter Other Faculty Department. It must be less than 256 characters.'
                        hasAnyError = true
                    }
                    else if (inputValues['Additional_License_2_Faculty_Department__c'] === "Other" && !inputValues['addi2OtherFacultyDept'] && field.dataset.validate === 'addi2OtherFacultyDept') {
                        message = 'Enter Additional Other Faculty Department'
                        hasAnyError = true
                    }
                    else if (inputValues['Additional_License_2_Faculty_Department__c'] === "Other" && inputValues['addi2OtherFacultyDept'] && field.dataset.validate === 'addi2OtherFacultyDept' && FormUtils.isLimitCharacters(inputValues['addi2OtherFacultyDept'], 255)) {
                        message = 'Enter Other Faculty Department. It must be less than 256 characters.'
                        hasAnyError = true
                    }
                    else if (inputValues['studentLicense'] && value === '' && field.dataset.validate === 'numStudLicense' || (inputValues['studentLicense'] && value !== '' && field.dataset.validate === 'numStudLicense' && (!Number.isInteger(parseInt(value)) || (parseInt(value) <= 0 || parseInt(value) > 1000)))) {
                        message = 'Numerical values only, cannot be 0, maximum 1,000.'
                        hasAnyError = true
                    }
                    else if (inputValues['additionStudLicense'] && value === '' && field.dataset.validate === 'addlicenseCourseTitle') {
                        message = 'Please enter course title.'
                        hasAnyError = true
                    }
                    else if (value !== "" && inputValues['additionStudLicense'] && field.dataset.validate === 'addlicenseCourseTitle' && FormUtils.isLimitCharacters(value, 255)) {
                        message = 'Please enter course title. It must be less than 256 characters.'
                        hasAnyError = true
                    }
                    else if (inputValues['additionStudLicense'] && value === '' && field.dataset.validate === 'addStudLicenseNeed' || (inputValues['additionStudLicense'] && value !== '' && field.dataset.validate === 'addStudLicenseNeed' && (!Number.isInteger(parseInt(value)) || (parseInt(value) <= 0 || parseInt(value) > 1000)))) {
                        message = 'Numerical values only, cannot be 0, maximum 1,000.'
                        hasAnyError = true
                    }
                    else if (inputValues['additionStudLicensenext'] && value === '' && field.dataset.validate === 'addLicenseCourseTitleNext') {
                        message = 'Please enter course title.'
                        hasAnyError = true
                    }
                    else if (value !== "" && inputValues['additionStudLicensenext'] && field.dataset.validate === 'addLicenseCourseTitleNext' && FormUtils.isLimitCharacters(value, 255)) {
                        message = 'Please enter course title. It must be less than 256 characters.'
                        hasAnyError = true
                    }
                    else if (inputValues['additionStudLicensenext'] && value === '' && field.dataset.validate === 'addStudLicenseNeededNext' || (inputValues['additionStudLicensenext'] && value !== '' && field.dataset.validate === 'addStudLicenseNeededNext' && (!Number.isInteger(parseInt(value)) || (parseInt(value) <= 0 || parseInt(value) > 1000)))) {
                        message = 'Numerical values only, cannot be 0, maximum 1,000.'
                        hasAnyError = true
                    }
                    else if (inputValues['labLicense'] && value === '' && field.dataset.validate === 'labNumOfComputer' || (inputValues['labLicense'] && value !== '' && field.dataset.validate === 'labNumOfComputer' && (!Number.isInteger(parseInt(value)) || (parseInt(value) <= 0 || parseInt(value) > 2000)))) {
                        message = 'Numerical values only, cannot be 0, maximum 2,000.'
                        hasAnyError = true
                    }
                    else if (inputValues['tableauCloudSite'] && value === '' && field.dataset.validate === 'tableauCloudDate') {
                        message = 'Please select date.'
                        hasAnyError = true
                    }
                    else if (inputValues['labLicense'] && value === '' && field.dataset.validate === 'labLicenceDate') {
                        message = 'Please select date.'
                        hasAnyError = true
                    }
                    else if (inputValues['termsAndCondition']?.showLegalCheckbox && field.id === 'legalText' && (inputValues['legalText'] === false || !inputValues['legalText'])) {
                        message = 'Please Accept the Privacy Statement'
                        hasAnyError = true
                    }
                }
            }

            if (field.tagName === 'TDS-COMBOBOX' && field.shadowRoot) {
                if (field.id === 'Country__c' && !inputValues['Country__c']) {
                    message = 'Please select country/region.'
                    hasAnyError = true
                }

                if (field.id === 'State__c' && inputValues['Country__c'] === "United States" && !inputValues['State__c']) {
                    message = 'Please select the state.'
                    hasAnyError = true
                }

                if (field.id === 'Canada_State__C' && inputValues['Country__c'] === "Canada" && !inputValues['Canada_State__C']) {
                    message = 'Please select the state.'
                    hasAnyError = true
                }

                else if (field.id === 'Course_Level__c' && !inputValues['Course_Level__c']) {
                    message = 'Please select the course level.'
                    hasAnyError = true
                }

                else if (field.id === 'Faculty_Department__c' && !inputValues['Faculty_Department__c']) {
                    message = 'Please select faculty/department.'
                    hasAnyError = true
                }

                else if (inputValues['individualLicense'] && field.id === 'Individual_License_Purpose__c' && !inputValues['Individual_License_Purpose__c']) {
                    message = 'Please select a plan to use Tableau.'
                    hasAnyError = true
                }

                else if (inputValues['studentLicense'] && field.id === 'Student_License_Course_Level__c' && !inputValues['Student_License_Course_Level__c']) {
                    message = 'Please select the course level.'
                    hasAnyError = true
                }

                else if (inputValues['studentLicense'] && field.id === 'Student_License_Faculty_Department__c' && !inputValues['Student_License_Faculty_Department__c']) {
                    message = 'Please select faculty/department.'
                    hasAnyError = true
                }

                else if (inputValues['additionStudLicense'] && field.id === 'Additional_Student_License1_Course_Level__c' && !inputValues['Additional_Student_License1_Course_Level__c']) {
                    message = 'Please select the course level.'
                    hasAnyError = true
                }

                else if (inputValues['additionStudLicense'] && field.id === 'Additional_License_1_Faculty_Department__c' && !inputValues['Additional_License_1_Faculty_Department__c']) {
                    message = 'Please select faculty/department.'
                    hasAnyError = true
                }

                else if (inputValues['additionStudLicensenext'] && field.id === 'Additional_License_2_Course_Level__c' && !inputValues['Additional_License_2_Course_Level__c']) {
                    message = 'Please select the course level.'
                    hasAnyError = true
                }

                else if (inputValues['additionStudLicensenext'] && field.id === 'Additional_License_2_Faculty_Department__c' && !inputValues['Additional_License_2_Faculty_Department__c']) {
                    message = 'Please select faculty/department.'
                    hasAnyError = true
                }

            }

            //File upload
            if (field.id === 'Upload_Logo__c') {
                const instructorURL = document.querySelector('#Instructor_Academic_Profile_Link__c').value;
                if (inputValues['Upload_Logo__c']?.length == 0 && !instructorURL) {
                    message = 'Upload at least 1 document with details about your course and/or role, or enter a valid URL to verify your academic status'
                    hasAnyError = true
                    showFileInputValidation(message)
                }
                else if (inputValues['Upload_Logo__c']?.length > 3) {
                    message = 'You can only upload up to 3 files'
                    hasAnyError = true
                    showFileInputValidation(message)
                }
                else if (!validateFileSizes(field)) {
                    message = 'Max file size allowed is 3MB'
                    hasAnyError = true
                    showFileInputValidation(message)
                }
                else {
                    showFileInputValidation('')
                }
            }

            if (hasAnyError) {
                valid = hasAnyError;
                dispatchFieldErrorsChanges({ id: field.id, value: message })

            } else {
                dispatchFieldErrorsChanges({ id: field.id, value: null })
            }
        })

        if (inputValues['studentLicense'] && !inputValues['Student_License_Course_Start_Date__c']) {
            dateError = true;
            dispatchFieldErrorsChanges({ id: 'Student_License_Course_Start_Date__c', value: 'Please select the start date.' });
        }

        if (inputValues['studentLicense'] && inputValues['Student_License_Course_Start_Date__c']) {
            dispatchFieldErrorsChanges({ id: 'Student_License_Course_Start_Date__c', value: null })
        }

        if (inputValues['studentLicense'] && !inputValues['Student_License_Course_End_Date__c']) {
            dateError = true;
            dispatchFieldErrorsChanges({ id: 'Student_License_Course_End_Date__c', value: 'Please select the end date.' });
        }

        if (inputValues['studentLicense'] && inputValues['Student_License_Course_End_Date__c']) {
            dispatchFieldErrorsChanges({ id: 'Student_License_Course_End_Date__c', value: null })
        }

        if (inputValues['studentLicense'] && inputValues['Student_License_Course_Start_Date__c'] && inputValues['Student_License_Course_End_Date__c'] && Date.parse(inputValues['Student_License_Course_End_Date__c']) < Date.parse(inputValues['Student_License_Course_Start_Date__c'])) {
            dateError = true;
            dispatchFieldErrorsChanges({ id: 'Student_License_Course_End_Date__c', value: 'End date should be greater than start date.' });
        }

        if (inputValues['studentLicense'] && inputValues['Student_License_Course_Start_Date__c'] && inputValues['Student_License_Course_End_Date__c'] && Date.parse(inputValues['Student_License_Course_End_Date__c']) > Date.parse(inputValues['Student_License_Course_Start_Date__c'])) {
            dispatchFieldErrorsChanges({ id: 'Student_License_Course_End_Date__c', value: null })
        }

        if (inputValues['additionStudLicense'] && !inputValues['Additional_License_1_Course_Start_Date__c']) {
            dateError = true;
            dispatchFieldErrorsChanges({ id: 'Additional_License_1_Course_Start_Date__c', value: 'Please select the start date.' });
        }

        if (inputValues['additionStudLicense'] && inputValues['Additional_License_1_Course_Start_Date__c']) {
            dispatchFieldErrorsChanges({ id: 'Additional_License_1_Course_Start_Date__c', value: null })
        }

        if (inputValues['additionStudLicense'] && !inputValues['Additional_License_1_Course_End_Date__c']) {
            dateError = true;
            dispatchFieldErrorsChanges({ id: 'Additional_License_1_Course_End_Date__c', value: 'Please select the end date.' });
        }

        if (inputValues['additionStudLicense'] && inputValues['Additional_License_1_Course_End_Date__c']) {
            dispatchFieldErrorsChanges({ id: 'Additional_License_1_Course_End_Date__c', value: null })
        }

        if (inputValues['additionStudLicense'] && inputValues['Additional_License_1_Course_Start_Date__c'] && inputValues['Additional_License_1_Course_End_Date__c'] && Date.parse(inputValues['Additional_License_1_Course_End_Date__c']) < Date.parse(inputValues['Additional_License_1_Course_Start_Date__c'])) {
            dateError = true;
            dispatchFieldErrorsChanges({ id: 'Additional_License_1_Course_End_Date__c', value: 'end date should be greater than start date.' });
        }

        if (inputValues['additionStudLicense'] && inputValues['Additional_License_1_Course_Start_Date__c'] && inputValues['Additional_License_1_Course_End_Date__c'] && Date.parse(inputValues['Additional_License_1_Course_End_Date__c']) > Date.parse(inputValues['Additional_License_1_Course_Start_Date__c'])) {
            dispatchFieldErrorsChanges({ id: 'Additional_License_1_Course_End_Date__c', value: null })
        }

        if (inputValues['additionStudLicensenext'] && !inputValues['Additional_License_2_Course_Start_Date__c']) {
            dateError = true;
            dispatchFieldErrorsChanges({ id: 'Additional_License_2_Course_Start_Date__c', value: 'Please select the start date.' });
        }

        if (inputValues['additionStudLicensenext'] && inputValues['Additional_License_2_Course_Start_Date__c']) {
            dispatchFieldErrorsChanges({ id: 'Additional_License_2_Course_Start_Date__c', value: null })
        }

        if (inputValues['additionStudLicensenext'] && !inputValues['Additional_License_2_Course_End_Date__c']) {
            dateError = true;
            dispatchFieldErrorsChanges({ id: 'Additional_License_2_Course_End_Date__c', value: 'Please select the end date.' });
        }

        if (inputValues['additionStudLicensenext'] && inputValues['Additional_License_2_Course_End_Date__c']) {
            dispatchFieldErrorsChanges({ id: 'Additional_License_2_Course_End_Date__c', value: null })
        }

        if (inputValues['additionStudLicensenext'] && inputValues['Additional_License_2_Course_Start_Date__c'] && inputValues['Additional_License_2_Course_End_Date__c'] && Date.parse(inputValues['Additional_License_2_Course_End_Date__c']) < Date.parse(inputValues['Additional_License_2_Course_Start_Date__c'])) {
            dateError = true;
            dispatchFieldErrorsChanges({ id: 'Additional_License_2_Course_End_Date__c', value: 'end date should be greater than start date.' });
        }

        if (inputValues['additionStudLicensenext'] && inputValues['Additional_License_2_Course_Start_Date__c'] && inputValues['Additional_License_2_Course_End_Date__c'] && Date.parse(inputValues['Additional_License_2_Course_End_Date__c']) > Date.parse(inputValues['Additional_License_2_Course_Start_Date__c'])) {
            dispatchFieldErrorsChanges({ id: 'Additional_License_2_Course_End_Date__c', value: null })
        }

        if (inputValues['tableauCloudSite'] && !inputValues['Cloud_Site_License_Needed_By_Date__c']) {
            dateError = true;
            dispatchFieldErrorsChanges({ id: 'Cloud_Site_License_Needed_By_Date__c', value: 'Please select the date.' });
        }

        if (inputValues['tableauCloudSite'] && inputValues['Cloud_Site_License_Needed_By_Date__c']) {
            dispatchFieldErrorsChanges({ id: 'Cloud_Site_License_Needed_By_Date__c', value: null })
        }

        if (inputValues['labLicense'] && !inputValues['Lab_License_Needed_By_Date__c']) {
            dateError = true;
            dispatchFieldErrorsChanges({ id: 'Lab_License_Needed_By_Date__c', value: 'Please select the date.' });
        }

        if (inputValues['labLicense'] && inputValues['Lab_License_Needed_By_Date__c']) {
            dispatchFieldErrorsChanges({ id: 'Lab_License_Needed_By_Date__c', value: null })
        }

        if (!recaptchaTokenFormHandler) {
            valid = true;
            dispatchFieldErrorsChanges({ id: 'recaptcha-widget', value: 'Please complete the re-captcha verification.' });
        } else {
            dispatchFieldErrorsChanges({ id: 'recaptcha-widget', value: null });
        }

        if (inputValues['Upload_Logo__c']?.length > 0 && !recaptchaToken) {
            valid = true;
            dispatchFieldErrorsChanges({ id: 'recaptcha-upload-widget', value: 'Please complete the re-captcha verification.' });
        } else {
            dispatchFieldErrorsChanges({ id: 'recaptcha-upload-widget', value: null });
        }

        return valid || dateError;
    }


    //  -- Removes error message on form field change --
    const reValidateField = (inputId, value) => {
        if (value !== '' && inputId === 'First_Name__c' && !FormUtils.isLimitCharacters(value, 127)) {
            dispatchFieldErrorsChanges({ id: inputId, value: null })
        }
        else if (value !== '' && inputId === 'Last_Name__c' && !FormUtils.isLimitCharacters(value, 127)) {
            dispatchFieldErrorsChanges({ id: inputId, value: null })
        }
        else if (value !== '' && inputId === 'Institute_Name__c' && !FormUtils.isLimitCharacters(value, 255)) {
            dispatchFieldErrorsChanges({ id: inputId, value: null })
        }
        else if (inputId === 'Institute_Email__c' && FormUtils.isValidEmail(value)) {
            dispatchFieldErrorsChanges({ id: inputId, value: null })
        }
        else if (inputId === 'confirmSchoolEmail' && document.getElementById('Institute_Email__c').value === value) {
            dispatchFieldErrorsChanges({ id: inputId, value: null })
        }
        else if (inputId === 'Country__c' && inputValues['Country__c'] !== '') {
            dispatchFieldErrorsChanges({ id: inputId, value: null })
        }
        else if (inputId === 'State__c' && value !== '') {
            dispatchFieldErrorsChanges({ id: inputId, value: null })
        }
        else if (inputId === 'Course_Level__c' && value !== '' && !FormUtils.isLimitCharacters(value, 255)) {
            dispatchFieldErrorsChanges({ id: inputId, value: null })
        }
        else if (inputId === 'Faculty_Department__c' && value !== '' && !FormUtils.isLimitCharacters(value, 255)) {
            dispatchFieldErrorsChanges({ id: inputId, value: null })
        }
        else if (inputId === 'Instructor_Academic_Profile_Link__c' && FormUtils.isValidUrl(value)) {
            dispatchFieldErrorsChanges({ id: inputId, value: null })
        }
    }

    const validateFileSizes = (fileInput) => {
        if (fileInput && fileInput.files) {
            const maxSize = 3 * 1024 * 1024; //3MB
            for (const oneFile of fileInput.files) {
                if (oneFile.size > maxSize) {
                    return false;
                }
            }
        }
        return true;
    }

    const getDropdownsOptions = () => {
        return {
            Course_Level__c: [
                'Primary/Secondary (K-12)',
                'Undergraduate',
                'Post Graduate'
            ],
            Faculty_Department__c: [
                'Business - Marketing',
                'Business - Accounting',
                'Business - Information Systems',
                'Business - Management',
                'Business - Finance',
                'Engineering - Computer Science',
                'Education',
                'Natural Sciences - Mathematics',
                'Natural Sciences - Geography',
                'Communications/Journalism',
                'Psychology',
                'Sociology',
                'Life Sciences & Medicine - Medicine',
                'Life Sciences & Medicine - Public Health',
                'Sports Management',
                'Public Policy',
                'Other'
            ],
            Student_License_Course_Level__c: [
                'Primary/Secondary (K-12)',
                'Undergraduate',
                'Post Graduate'
            ],
            Student_License_Faculty_Department__c: [
                'Business - Marketing',
                'Business - Accounting',
                'Business - Information Systems',
                'Business - Management',
                'Business - Finance',
                'Engineering - Computer Science',
                'Education',
                'Natural Sciences - Mathematics',
                'Natural Sciences - Geography',
                'Communications/Journalism',
                'Psychology',
                'Sociology',
                'Life Sciences & Medicine - Medicine',
                'Life Sciences & Medicine - Public Health',
                'Sports Management',
                'Public Policy',
                'Other'
            ],
            Additional_Student_License1_Course_Level__c: [
                'Primary/Secondary (K-12)',
                'Undergraduate',
                'Post Graduate'
            ],
            Additional_License_1_Faculty_Department__c: [
                'Business - Marketing',
                'Business - Accounting',
                'Business - Information Systems',
                'Business - Management',
                'Business - Finance',
                'Engineering - Computer Science',
                'Education',
                'Natural Sciences - Mathematics',
                'Natural Sciences - Geography',
                'Communications/Journalism',
                'Psychology',
                'Sociology',
                'Life Sciences & Medicine - Medicine',
                'Life Sciences & Medicine - Public Health',
                'Sports Management',
                'Public Policy',
                'Other'
            ],
            Additional_License_2_Course_Level__c: [
                'Primary/Secondary (K-12)',
                'Undergraduate',
                'Post Graduate'
            ],
            Additional_License_2_Faculty_Department__c: [
                'Business - Marketing',
                'Business - Accounting',
                'Business - Information Systems',
                'Business - Management',
                'Business - Finance',
                'Engineering - Computer Science',
                'Education',
                'Natural Sciences - Mathematics',
                'Natural Sciences - Geography',
                'Communications/Journalism',
                'Psychology',
                'Sociology',
                'Life Sciences & Medicine - Medicine',
                'Life Sciences & Medicine - Public Health',
                'Sports Management',
                'Public Policy',
                'Other'
            ],
            Tableau_Needs__c: [
                'Teaching purpose only',
                'Noncommercial academic research only',
                'Both teaching & noncommercial academic research'
            ],
            Individual_License_Purpose__c: [
                'Teaching purposes only',
                'Noncommercial academic research only',
                'Teaching & noncommercial academic research'
            ],
            State__c: [
                'Alabama',
                'Alaska',
                'Arizona',
                'Arkansas',
                'California',
                'Colorado',
                'Connecticut',
                'Delaware',
                'Florida',
                'Georgia',
                'Hawaii',
                'Idaho',
                'Illinois',
                'Indiana',
                'Iowa',
                'Kansas',
                'Kentucky',
                'Louisiana',
                'Maine',
                'Maryland',
                'Massachusetts',
                'Michigan',
                'Minnesota',
                'Mississippi',
                'Missouri',
                'Montana',
                'Nebraska',
                'Nevada',
                'New Hampshire',
                'New Jersey',
                'New Mexico',
                'New York',
                'North Carolina',
                'North Dakota',
                'Ohio',
                'Oklahoma',
                'Oregon',
                'Pennsylvania',
                'Rhode Island',
                'South Carolina',
                'South Dakota',
                'Tennessee',
                'Texas',
                'Utah',
                'Vermont',
                'Virginia',
                'Washington',
                'West Virginia',
                'Wisconsin',
                'Wyoming'
            ],
            Canada_State__C: [
                'Newfoundland And Labrador',
                'Prince Edward Island',
                'Nova Scotia',
                'New Brunswick',
                'Quebec',
                'Ontario',
                'Manitoba',
                'Saskatchewan',
                'Alberta',
                'British Columbia',
                'Yukon',
                'Northwest Territories',
                'Nunavut'
            ]
        }
    }


    const handleTdsInputOnChange = useCallback(e => {
        const val = e.nativeEvent ? e.nativeEvent.target.value : e.detail
        const inputId = e.target.id
        if (inputId) {
            dispatchFieldChanges({ id: inputId, value: val });
            reValidateField(inputId, val);
        }
    }, [])

    const handleTdsComboboxOnChange = useCallback(e => {
        const val = e.nativeEvent ? e.nativeEvent.target.value : e.detail
        const inputId = e.target.id
        if (inputId) {
            if (e.target.multiple) {
                const arr = JSON.parse(JSON.stringify(val))
                dispatchFieldChanges({ id: inputId, value: arr })

            } else {
                dispatchFieldChanges({ id: inputId, value: val })
                reValidateField(inputId, val);
            }
        }
    });

    const asyncPrepareFields = async () => {
        const tdsElementNames = ['tds-input', 'tds-combobox', 'tds-checkbox']
        const promises = [...tdsElementNames].map(element => {
            if (element === "tds-input") {
                customElements.whenDefined("tds-input").then(() => {
                    document.querySelectorAll("tds-input").forEach(input => {
                        if (input.dataset && !Object.hasOwnProperty.call(input.dataset, 'onChangeBinded')) {
                            // Add Event Listener
                            input.addEventListener('change', handleTdsInputOnChange)
                            input.dataset.onChangeBinded = true
                        }
                    })
                })
            }

            if (element === "tds-combobox") {
                customElements.whenDefined("tds-combobox").then(() => {
                    document.querySelectorAll("tds-combobox").forEach(input => {
                        if (input.dataset && !Object.hasOwnProperty.call(input.dataset, 'onChangeBinded')) {
                            input.dataset.onChangeBinded = true
                            // Add Event Listener
                            input.addEventListener('change', handleTdsComboboxOnChange)
                        }
                    })
                })
            }
        })

        // Wait for all the undefinedElements to be defined
        await Promise.all(promises)
    }

    const clearFormDetails = (e) => {
        e.preventDefault();
        setShowModal(false)
        setApiMessage();
        dispatchFieldChanges({ type: 'CLEARSTATE', value: null });
        dispatchFieldErrorsChanges({ type: 'CLEARSTATE', value: null });
        window.location = "https://www.tableau.com/academic/teaching";
    }

    return (
        <LWCLayout slug={slug}>
            <Helmet>
                <title>Tableau Form</title>
            </Helmet>
            {isLoggedUser && (
                <div className="tableau-content">
                    <div className="img-logo">
                        <img alt="tableau form" src="https://developer.salesforce.com/resources2/tableau/Tableau-From-Salesforce-Logo-COLOR.svg" />
                    </div>
                    <div className="header-title">
                        <h2 className="sub-title">Tableau for Teaching</h2>
                        <h1 className="main-title">Request Individual & Course Licenses</h1>
                        <p className="title-desc">By submitting a request, you’re on your way to getting started with Tableau software and incorporating visual analytics into any curriculum. For information on eligibility, documentation, and more, please review our <a href="https://community.tableau.com/s/news/a0A4T000002O0vaUAC/tableau-for-teaching-faqs" target="_blank">Frequently Asked Questions.</a> </p>
                    </div>
                    <div className="first-page">
                        <h2 className="title">
                            Contact Information
                        </h2>
                        <div className="slds-p-around_small">
                            <tds-input
                                id="First_Name__c"
                                type="text"
                                label="First Name"
                                data-validate="firstName"
                                placeholder="First Name"
                                required="true"
                                value={inputValues['First_Name__c']}
                                error-message={fieldErrors['First_Name__c']} />
                        </div>
                        <div className="slds-p-around_small">
                            <tds-input
                                id="Last_Name__c"
                                type="text"
                                data-validate="lastName"
                                label="Last Name"
                                placeholder="Last Name"
                                required="true"
                                value={inputValues['Last_Name__c']}
                                error-message={fieldErrors['Last_Name__c']} />
                        </div>
                        <div className="slds-p-around_small">
                            <tds-input
                                id="Institute_Name__c"
                                type="text"
                                label="Name of Institution"
                                data-validate="instituteName"
                                placeholder="Name of School or Institution"
                                required="true"
                                value={inputValues['Institute_Name__c']}
                                error-message={fieldErrors['Institute_Name__c']} />
                        </div>
                        <div className="slds-p-around_small">
                            <tds-input
                                id="Institute_Email__c"
                                type="email"
                                data-validate="email"
                                label="School-Issued Email Address"
                                placeholder="E.g., yourname@school.edu"
                                required="true"
                                value={inputValues['Institute_Email__c']}
                                error-message={fieldErrors['Institute_Email__c']} />
                        </div>
                        <div className="slds-p-around_small">
                            <tds-input
                                id="confirmSchoolEmail"
                                type="email"
                                data-validate="confirmemail"
                                label="Confirm School-Issued Email Address"
                                placeholder="E.g., yourname@school.edu"
                                required="true"
                                value={inputValues['confirmSchoolEmail']}
                                error-message={fieldErrors['confirmSchoolEmail']} />
                        </div>
                        <div className="slds-p-around_small">
                            <div className="u-input-label">
                                <span className="u-required-simbol">*</span>
                                Country/Region of Residence
                            </div>
                            <tds-combobox
                                required="true"
                                placeholder="Country / Region"
                                id="Country__c"
                                data-validate="country"
                                value={inputValues['Country__c']}
                                error-message={fieldErrors['Country__c']} />
                        </div>
                        <div className={`slds-p-around_small ${inputValues['Country__c'] === 'United States' ? '' : 'hidden-div'}`}>
                            <div className="u-input-label">
                                <span className="u-required-simbol">*</span>
                                State
                            </div>
                            <tds-combobox
                                required="true"
                                placeholder="Select State"
                                id="State__c"
                                data-validate="state"
                                value={inputValues['State__c']}
                                error-message={fieldErrors['State__c']} />
                        </div>
                        <div className={`slds-p-around_small ${inputValues['Country__c'] === 'Canada' ? '' : 'hidden-div'}`}>
                            <div className="u-input-label">
                                <span className="u-required-simbol">*</span>
                                State
                            </div>
                            <tds-combobox
                                required="true"
                                placeholder="Select State"
                                id="Canada_State__C"
                                data-validate="state"
                                value={inputValues['Canada_State__C']}
                                error-message={fieldErrors['Canada_State__C']} />
                        </div>
                    </div>

                    <div className="second-page">
                        <h2 className="title">
                            Instructor / Academic Researcher Verification
                        </h2>
                        <p className="slds-p-around_small">To verify your instructor or researcher status, please include a publicly-facing faculty profile and/or upload up to 3 pieces of documentation. </p>

                        <div className="slds-p-around_small">
                            <div style={{ display: 'flex', padding: '4px 0' }}>
                                <div className="u-field-title" style={{ color: '#0070D2', paddingRight: '10px', lineHeight: '25px' }}>What is needed in my profile or documentation?</div>
                                <tds-tooltip placement="top">
                                    <a href="#" slot="trigger" style={{ color: '#0070D2' }}>
                                        <tds-icon size="large" symbol="info_alt"></tds-icon>
                                    </a>
                                    <div slot="tooltip">
                                        Documentation must include your
                                        <ol className="tooltip-instructor" style={{ listStyle: "circle", listStylePosition: "inside" }}>
                                            <li>Full name</li>
                                            <li>Position or title</li>
                                            <li>Current year/term</li>
                                        </ol>
                                        <p>This could be a a course syllabus, employment letter, or any official school-issued document. Review our FAQ page for more information on eligibility. </p>
                                        <br />
                                        <p>If you have any questions, or need to provide additional documents, email tft@tableau.com with the subject: Instructor Verification.</p>
                                    </div>
                                </tds-tooltip>
                            </div>
                        </div>
                        <div className="slds-p-around_small flex-container">
                            <div className="flex-item">
                                <div className="u-input-label">
                                    <span className="u-required-simbol">*</span>
                                    Course Level
                                </div>
                                <tds-combobox
                                    required="true"
                                    placeholder="Select one"
                                    id="Course_Level__c"
                                    data-validate="courseLevel"
                                    value={inputValues['Course_Level__c']}
                                    error-message={fieldErrors['Course_Level__c']} />
                            </div>
                            <div className="flex-item">
                                <div className="u-input-label">
                                    <span className="u-required-simbol">*</span>
                                    Faculty/Department
                                </div>
                                <tds-combobox
                                    required="true"
                                    placeholder="Select one"
                                    id="Faculty_Department__c"
                                    data-validate="facultyDepartment"
                                    value={inputValues['Faculty_Department__c']}
                                    error-message={fieldErrors['Faculty_Department__c']}
                                />
                                <div className={`margin-top20 ${inputValues['Faculty_Department__c'] === "Other" ? '' : 'hidden-div'}`}>
                                    <tds-input
                                        id="otherFacultyDept"
                                        type="text"
                                        data-validate="otherFacultyDept"
                                        label=""
                                        placeholder="Enter Other Faculty Department"
                                        required="true"
                                        value={inputValues['otherFacultyDept']}
                                        error-message={fieldErrors['otherFacultyDept']}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="slds-p-around_small">
                            <div className="u-input-label">
                                <span className="u-required-simbol">*</span>
                                Link to Instructor or Academic Researcher Profile URL
                            </div>
                            <tds-input
                                id="Instructor_Academic_Profile_Link__c"
                                type="text"
                                label=""
                                placeholder="E.g., yourprofilename.com"
                                data-validate="url"
                                value={inputValues['Instructor_Academic_Profile_Link__c']}
                                error-message={fieldErrors['Instructor_Academic_Profile_Link__c']} />

                            {/* File Upload Section Starts */}
                            <div className="u-input-label margin-top20">
                                Upload up to 3 documents to verify your status as an instructor or academic researcher. Examples include: a course syllabus or a letter of employment. The document must include your name and current year/term. More information can be found on our <a href="https://community.tableau.com/s/news/a0A4T000002O0vaUAC/tableau-for-teaching-faqs" target="_blank">FAQ page</a>. Max file size is 3MB per file. Supported file types: .pdf,  .doc, .docx, .jpeg, .jpg, .png, .pages
                            </div>
                            <div class="slds-form-element">
                                <div className="slds-form-element__control">
                                    <div className="slds-file-selector1 slds-file-selector_files1">
                                        <div className="slds-file-selector__dropzone">
                                            <input
                                                type="file"
                                                multiple="multiple"
                                                name='files[]'
                                                className="slds-file-selector__input slds-assistive-text u-file-uploader"
                                                accept=".jpeg,.jpg,.png,.pdf,.doc,.docx,.pages"
                                                id="Upload_Logo__c"
                                                data-validate="Upload_Logo__c"
                                                required="required"
                                                aria-labelledby="file-selector-primary-label-205 file-selector-secondary-label206"
                                                onChange={handleInputFileOnChange} />
                                            <label className="slds-file-selector__body u-cursor-pointer" htmlFor="Upload_Logo__c" id="Upload_Logo__c_label">
                                                <div className="slds-file-selector__button slds-button slds-button_neutral1 u-button-text_neutral u-full-width">
                                                    <div className="slds-grid slds-grid_align-spread slds-grid_vertical-align-center u-full-width">
                                                        <div className="slds-col">
                                                            File Upload
                                                        </div>
                                                        <div className="slds-col">
                                                            <i className="icon-upload" />
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* <span class="slds-file-selector__text slds-medium-show Upload_Logo__c_selected_files"></span> */}
                                            </label>
                                        </div>
                                    </div>
                                    {inputValues['Upload_Logo__c'] &&
                                        inputValues['Upload_Logo__c'].map((list, index) => {
                                            return (
                                                <div className='file-list'>
                                                    <span>{list.file.name}</span>
                                                    <span className='remove-files' onClick={() => removeFile(list.FID)}>X</span></div>
                                            )
                                        })
                                    }
                                </div>
                                <div class="slds-form-element__help" id=""></div>
                            </div>
                            <div className="sixth-page slds-p-around_small slds-align_absolute-center">
                                <ReCAPTCHA
                                    ref={recaptchaRef}
                                    sitekey={process.env.GATSBY_RECAPTCHA_SITE_KEY}
                                    onChange={handleRecaptcha}
                                    onExpired={handleRecaptchaFail}
                                    onErrored={handleRecaptchaFail} />
                            </div>
                            {fieldErrors['recaptcha-upload-widget'] &&
                                <div class="slds-align_absolute-center slds-p-around_small input-error" id="recaptcha-error">{fieldErrors['recaptcha-upload-widget']} </div>
                            }

                            {/* File Upload Section Ends */}

                        </div>
                    </div>

                    <div className="third-page">
                        <h2 className="title">
                            Individual Instructor or Academic Researcher License
                        </h2>
                        <p className="slds-p-around_small">Receive a one-year individual instructor or academic researcher license for teaching and/or noncommercial academic research that can be installed on up to 2 machines. </p>
                        <div className="slds-p-around_small">
                            <tds-input type="checkbox" id="individualLicense" label="I need an individual license." value="individualLicense" />
                        </div>
                    </div>

                    <div className={`slds-p-around_small ${!inputValues['individualLicense'] ? 'hidden-div' : ''}`}>
                        <div className="rounded-box">
                            <div className="u-input-label">
                                <span className="u-required-simbol">*</span>
                                For what do you plan to use Tableau?
                            </div>
                            <tds-combobox
                                id="Individual_License_Purpose__c"
                                required="true"
                                placeholder="Select one"
                                data-validate="individualLicense"
                                value={inputValues['Individual_License_Purpose__c']}
                                error-message={fieldErrors['Individual_License_Purpose__c']} />
                        </div>
                    </div>

                    <div className="fourth-page">
                        <h2 className="title">
                            Student Course Licenses
                        </h2>
                        <p className="slds-p-around_small">
                            Student course licenses are used to activate Tableau Desktop (the authoring tool) and Tableau Prep (the data prep tool). Bulk student licenses are for use on student’s personal computers and issued for the duration of the course. The key is distributed to an entire class to be installed locally on student’s personal computers and are valid for the duration of the course. <i>Please Note: these licenses are meant to be used for quarter or semester courses, and 8 months is the maximum duration.</i></p>
                        <div className="slds-p-around_small">
                            <tds-input type="checkbox" id="studentLicense" label="I need a student course license." />
                        </div>

                        <div className={`slds-p-around_small ${inputValues['studentLicense'] ? '' : 'hidden-div'}`}>
                            <div className="rounded-box">
                                <div className="flex-container">
                                    <div className="flex-item">
                                        <div className="u-input-label">
                                            <span className="u-required-simbol">*</span>
                                            Course Level
                                        </div>
                                        <tds-combobox
                                            id="Student_License_Course_Level__c"
                                            required="true"
                                            placeholder="Select one"
                                            data-validate="studentLicense"
                                            value={inputValues['Student_License_Course_Level__c']}
                                            error-message={fieldErrors['Student_License_Course_Level__c']} />

                                    </div>
                                    <div className="flex-item">
                                        <div className="u-input-label">
                                            <span className="u-required-simbol">*</span>
                                            Faculty/Department
                                        </div>
                                        <tds-combobox
                                            id="Student_License_Faculty_Department__c"
                                            required="true"
                                            placeholder="Select one"
                                            data-validate="studFacultyDept"
                                            value={inputValues['Student_License_Faculty_Department__c']}
                                            error-message={fieldErrors['Student_License_Faculty_Department__c']} />

                                        <div className={`margin-top20 ${inputValues['Student_License_Faculty_Department__c'] === "Other" ? '' : 'hidden-div'}`}>
                                            <tds-input
                                                id="studOtherFacultyDept"
                                                type="text"
                                                data-validate="studOtherFacultyDept"
                                                label=""
                                                placeholder="Enter Student Other Faculty Department"
                                                required="true"
                                                value={inputValues['studOtherFacultyDept']}
                                                error-message={fieldErrors['studOtherFacultyDept']}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="flex-container">
                                    <div className="flex-item">
                                        <div className="u-input-label">
                                            <span className="u-required-simbol">*</span>
                                            Course Title
                                        </div>
                                        <tds-input
                                            type="text"
                                            id="Student_License_Course_Title__c"
                                            placeholder="Enter Course Title here"
                                            required="true"
                                            data-validate="studCourseTitle"
                                            value={inputValues['Student_License_Course_Title__c']}
                                            error-message={fieldErrors['Student_License_Course_Title__c']} />
                                    </div>
                                    <div className="flex-item">
                                        <div className="u-input-label">
                                            <span className="u-required-simbol">*</span>
                                            Number of activations needed on key
                                        </div>
                                        <tds-input
                                            type="text"
                                            id="Number_of_Student_License_Needed__c"
                                            placeholder="Enter Number"
                                            required="true"
                                            data-validate="numStudLicense"
                                            value={inputValues['Number_of_Student_License_Needed__c']}
                                            error-message={fieldErrors['Number_of_Student_License_Needed__c']} />
                                    </div>
                                </div>
                                <div className="flex-container">
                                    <div className="flex-item">
                                        <div className="u-input-label">
                                            <span className="u-required-simbol">*</span>
                                            Course Start Date
                                        </div>
                                        <DatePicker
                                            className={`${fieldErrors['Student_License_Course_Start_Date__c'] ? 'input-error-box' : ''}`}
                                            id="Student_License_Course_Start_Date__c"
                                            data-validate="studLicnStartDate"
                                            onChange={(e) => onChangeDate('Student_License_Course_Start_Date__c', e, 'studEndMaxDate')}
                                            value={inputValues['Student_License_Course_Start_Date__c']}
                                            minDate={new Date()}
                                            format="y-M-d"
                                        />
                                        {fieldErrors['Student_License_Course_Start_Date__c'] && (
                                            <div className='input-error'>{fieldErrors['Student_License_Course_Start_Date__c']}</div>
                                        )}
                                    </div>
                                    <div className="flex-item">
                                        <div className="u-input-label">
                                            <span className="u-required-simbol">*</span>
                                            Course End Date
                                        </div>
                                        <DatePicker
                                            className={`${fieldErrors['Student_License_Course_End_Date__c'] ? 'input-error-box' : ''}`}
                                            id="Student_License_Course_End_Date__c"
                                            data-validate="studLicnEndDate"
                                            onChange={(e) => onChangeDate('Student_License_Course_End_Date__c', e)}
                                            value={inputValues['Student_License_Course_End_Date__c']}
                                            minDate={new Date()}
                                            maxDate={inputValues['studEndMaxDate']}
                                            format="y-M-d"
                                        />
                                        {fieldErrors['Student_License_Course_End_Date__c'] && (
                                            <div className='input-error'>{fieldErrors['Student_License_Course_End_Date__c']}</div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <h2 className="title margin-top20">
                                Additional Course: Student Course Licenses
                            </h2>
                            <div className="slds-p-around_small">
                                <tds-input type="checkbox" id="additionStudLicense" label="I need an additional student course license." />
                            </div>
                            <div className={`rounded-box ${inputValues['additionStudLicense'] ? '' : 'hidden-div'} `}>
                                <div className="flex-container">
                                    <div className="flex-item">
                                        <div className="u-input-label">
                                            <span className="u-required-simbol">*</span>
                                            Course Level
                                        </div>
                                        <tds-combobox
                                            id="Additional_Student_License1_Course_Level__c"
                                            required="true"
                                            placeholder="Select one"
                                            data-validate="StudLicenseCourse"
                                            value={inputValues['Additional_Student_License1_Course_Level__c']}
                                            error-message={fieldErrors['Additional_Student_License1_Course_Level__c']} />
                                    </div>
                                    <div className="flex-item">
                                        <div className="u-input-label">
                                            <span className="u-required-simbol">*</span>
                                            Faculty/Department
                                        </div>
                                        <tds-combobox
                                            id="Additional_License_1_Faculty_Department__c"
                                            required="true"
                                            placeholder="Select one"
                                            data-validate="licenseFacultyDept"
                                            value={inputValues['Additional_License_1_Faculty_Department__c']}
                                            error-message={fieldErrors['Additional_License_1_Faculty_Department__c']} />
                                        <div className={`margin-top20 ${inputValues['Additional_License_1_Faculty_Department__c'] === "Other" ? '' : 'hidden-div'}`}>
                                            <tds-input
                                                id="addiOtherFacultyDept"
                                                type="text"
                                                data-validate="addiOtherFacultyDept"
                                                label=""
                                                placeholder="Enter Additional Other Faculty Department"
                                                required="true"
                                                value={inputValues['addiOtherFacultyDept']}
                                                error-message={fieldErrors['addiOtherFacultyDept']}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="flex-container">
                                    <div className="flex-item">
                                        <div className="u-input-label">
                                            <span className="u-required-simbol">*</span>
                                            Course Title
                                        </div>
                                        <tds-input type="text"
                                            id="Additional_License_1_Course_Title__c"
                                            placeholder="Enter Course Title here"
                                            required="true"
                                            data-validate="addlicenseCourseTitle"
                                            value={inputValues['Additional_License_1_Course_Title__c']}
                                            error-message={fieldErrors['Additional_License_1_Course_Title__c']} />
                                    </div>
                                    <div className="flex-item">
                                        <div className="u-input-label">
                                            <span className="u-required-simbol">*</span>
                                            Number of activations needed on key
                                        </div>
                                        <tds-input
                                            type="text"
                                            id="Additional_Student_License_1_Needed__c" placeholder="Enter Number"
                                            required="true"
                                            data-validate="addStudLicenseNeed"
                                            value={inputValues['Additional_Student_License_1_Needed__c']}
                                            error-message={fieldErrors['Additional_Student_License_1_Needed__c']} />
                                    </div>
                                </div>
                                <div className="flex-container">
                                    <div className="flex-item">
                                        <div className="u-input-label">
                                            <span className="u-required-simbol">*</span>
                                            Course Start Date
                                        </div>
                                        <DatePicker
                                            className={`${fieldErrors['Additional_License_1_Course_Start_Date__c'] ? 'input-error-box' : ''}`}
                                            id="Additional_License_1_Course_Start_Date__c"
                                            onChange={(e) => onChangeDate('Additional_License_1_Course_Start_Date__c', e, 'addEndMaxDate')}
                                            value={inputValues['Additional_License_1_Course_Start_Date__c']}
                                            minDate={new Date()}
                                            format="y-M-d"
                                        />
                                        {fieldErrors['Additional_License_1_Course_Start_Date__c'] && (
                                            <div className='input-error'>{fieldErrors['Additional_License_1_Course_Start_Date__c']}</div>
                                        )}
                                    </div>
                                    <div className="flex-item">
                                        <div className="u-input-label">
                                            <span className="u-required-simbol">*</span>
                                            Course End Date
                                        </div>
                                        <DatePicker
                                            className={`${fieldErrors['Additional_License_1_Course_End_Date__c'] ? 'input-error-box' : ''}`}
                                            id="Additional_License_1_Course_End_Date__c"
                                            onChange={(e) => onChangeDate('Additional_License_1_Course_End_Date__c', e)}
                                            value={inputValues['Additional_License_1_Course_End_Date__c']}
                                            minDate={new Date()}
                                            maxDate={inputValues['addEndMaxDate']}
                                            format="y-M-d"
                                        />
                                        {fieldErrors['Additional_License_1_Course_End_Date__c'] && (
                                            <div className='input-error'>{fieldErrors['Additional_License_1_Course_End_Date__c']}</div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <h2 className="title">
                                Additional Course: Student Course Licenses
                            </h2>
                            <div className="slds-p-around_small">
                                <tds-input type="checkbox" id="additionStudLicensenext" label="I need an additional student course license." />
                            </div>
                            <div className={`rounded-box ${inputValues['additionStudLicensenext'] ? '' : 'hidden-div'}`}>
                                <div className="flex-container">
                                    <div className="flex-item">
                                        <div className="u-input-label">
                                            <span className="u-required-simbol">*</span>
                                            Course Level
                                        </div>
                                        <tds-combobox
                                            id="Additional_License_2_Course_Level__c"
                                            required="true"
                                            placeholder="Select one"
                                            data-validate="addLicenseCourseNext"
                                            value={inputValues['Additional_License_2_Course_Level__c']}
                                            error-message={fieldErrors['Additional_License_2_Course_Level__c']} />
                                    </div>
                                    <div className="flex-item">
                                        <div className="u-input-label">
                                            <span className="u-required-simbol">*</span>
                                            Faculty/Department
                                        </div>
                                        <tds-combobox
                                            id="Additional_License_2_Faculty_Department__c"
                                            required="true"
                                            placeholder="Select one"
                                            data-validate="addLicenseFacultyDeptNext"
                                            value={inputValues['Additional_License_2_Faculty_Department__c']}
                                            error-message={fieldErrors['Additional_License_2_Faculty_Department__c']} />
                                        <div className={`margin-top20 ${inputValues['Additional_License_2_Faculty_Department__c'] === "Other" ? '' : 'hidden-div'}`}>
                                            <tds-input
                                                id="addi2OtherFacultyDept"
                                                type="text"
                                                data-validate="addi2OtherFacultyDept"
                                                label=""
                                                placeholder="Enter Additional Other Faculty Department"
                                                required="true"
                                                value={inputValues['addi2OtherFacultyDept']}
                                                error-message={fieldErrors['addi2OtherFacultyDept']}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="flex-container">
                                    <div className="flex-item">
                                        <div className="u-input-label">
                                            <span className="u-required-simbol">*</span>
                                            Course Title
                                        </div>
                                        <tds-input
                                            id="Additional_License_2_Course_Title__c"
                                            type="text"
                                            placeholder="Enter Course Title here"
                                            required="true"
                                            data-validate="addLicenseCourseTitleNext"
                                            value={inputValues['Additional_License_2_Course_Title__c']}
                                            error-message={fieldErrors['Additional_License_2_Course_Title__c']} />
                                    </div>
                                    <div className="flex-item">
                                        <div className="u-input-label">
                                            <span className="u-required-simbol">*</span>
                                            Number of activations needed on key
                                        </div>
                                        <tds-input
                                            type="text"
                                            id="Additional_Student_License_2_Needed__c" placeholder="Enter Number"
                                            required="true"
                                            data-validate="addStudLicenseNeededNext"
                                            value={inputValues['Additional_Student_License_2_Needed__c']}
                                            error-message={fieldErrors['Additional_Student_License_2_Needed__c']} />
                                    </div>
                                </div>
                                <div className="flex-container">
                                    <div className="flex-item">
                                        <div className="u-input-label">
                                            <span className="u-required-simbol">*</span>
                                            Course Start Date
                                        </div>
                                        <DatePicker
                                            className={`${fieldErrors['Additional_License_2_Course_Start_Date__c'] ? 'input-error-box' : ''}`}
                                            id="Additional_License_2_Course_Start_Date__c"
                                            onChange={(e) => onChangeDate('Additional_License_2_Course_Start_Date__c', e, 'add2EndMaxDate')}
                                            value={inputValues['Additional_License_2_Course_Start_Date__c']}
                                            minDate={new Date()}
                                            format="y-M-d"
                                        />
                                        {fieldErrors['Additional_License_2_Course_Start_Date__c'] && (
                                            <div className='input-error'>{fieldErrors['Additional_License_2_Course_Start_Date__c']}</div>
                                        )}
                                    </div>
                                    <div className="flex-item">
                                        <div className="u-input-label">
                                            <span className="u-required-simbol">*</span>
                                            Course End Date
                                        </div>
                                        <DatePicker
                                            className={`${fieldErrors['Additional_License_2_Course_End_Date__c'] ? 'input-error-box' : ''}`}
                                            id="Additional_License_2_Course_End_Date__c"
                                            onChange={(e) => onChangeDate('Additional_License_2_Course_End_Date__c', e)}
                                            value={inputValues['Additional_License_2_Course_End_Date__c']}
                                            minDate={new Date()}
                                            maxDate={inputValues['add2EndMaxDate']}
                                            format="y-M-d"
                                        />
                                        {fieldErrors['Additional_License_2_Course_End_Date__c'] && (
                                            <div className='input-error'>{fieldErrors['Additional_License_2_Course_End_Date__c']}</div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="fourth-page">
                        <h2 className="title">
                            Tableau Cloud
                        </h2>
                        <p className="slds-p-around_small">Tableau Cloud is a platform for students to share and collaborate. Sites are issued for 1 year and allow for 100 users at once. A single Tableau Cloud site can be used to manage multiple courses. Verified instructors are eligible to receive one Tableau Cloud site for teaching purposes only. The instructor will become the Site Owner and Site Administrator and will be responsible for site activation, maintenance, and renewal.</p>
                        <div className="slds-p-around_small">
                            <tds-input
                                type="checkbox"
                                id="tableauCloudSite"
                                label="I need a Tableau Cloud Site" />
                        </div>
                    </div>

                    <div className={`slds-p-around_small ${inputValues['tableauCloudSite'] ? '' : 'hidden-div'}`}>
                        <div className="rounded-box">
                            <div className="u-input-label">
                                <span className="u-required-simbol">*</span>
                                Date Needed By
                            </div>
                            <DatePicker
                                className={`${fieldErrors['Cloud_Site_License_Needed_By_Date__c'] ? 'input-error-box' : ''}`}
                                id="Cloud_Site_License_Needed_By_Date__c"
                                onChange={(e) => onChangeDate('Cloud_Site_License_Needed_By_Date__c', e)}
                                value={inputValues['Cloud_Site_License_Needed_By_Date__c']}
                                minDate={new Date()}
                                data-validate="cloudSiteLicenseDate"
                                format="y-M-d"
                            />
                            {fieldErrors['Cloud_Site_License_Needed_By_Date__c'] && (
                                <div className='input-error'>{fieldErrors['Cloud_Site_License_Needed_By_Date__c']}</div>
                            )}
                        </div>
                    </div>

                    <div className="fourth-page">
                        <h2 className="title">
                            Lab Licenses
                        </h2>
                        <p className="slds-p-around_small">Lab licenses are used to activate Tableau Desktop and Tableau Prep at university computer labs, either onto physical machines or virtual non-persistent machines. Lab licenses are issued for a one-year duration and can be requested by instructors or IT Administrators.</p>
                        <div className="slds-p-around_small">
                            <tds-input type="checkbox" id="labLicense" label="I need a lab license." />
                        </div>
                    </div>
                    <div className={`slds-p-around_small ${inputValues['labLicense'] ? '' : 'hidden-div'}`}>
                        <div className="rounded-box">
                            <div className="u-input-label">
                                <span className="u-required-simbol">*</span>
                                Number of lab computers
                            </div>
                            <tds-input
                                type="text"
                                id="Number_of_Lab_Licenses__c"
                                placeholder="Enter number of computers that need a license"
                                required="true"
                                data-validate="labNumOfComputer"
                                value={inputValues['Number_of_Lab_Licenses__c']}
                                error-message={fieldErrors['Number_of_Lab_Licenses__c']} />
                            <div className="u-input-label">
                                <span className="u-required-simbol">*</span>
                                Date Needed
                            </div>
                            <DatePicker
                                className={`${fieldErrors['Lab_License_Needed_By_Date__c'] ? 'input-error-box' : ''}`}
                                id="Lab_License_Needed_By_Date__c"
                                onChange={(e) => onChangeDate('Lab_License_Needed_By_Date__c', e)}
                                value={inputValues['Lab_License_Needed_By_Date__c']}
                                minDate={new Date()}
                                format="y-M-d"
                            />
                            {fieldErrors['Lab_License_Needed_By_Date__c'] && (
                                <div className='input-error'>{fieldErrors['Lab_License_Needed_By_Date__c']}</div>
                            )}
                        </div>
                    </div>

                    <div className="separator slds-p-top_small slds-m-top_small slds-m-bottom_medium  slds-m-horizontal_small"></div>

                    {inputValues['termsAndCondition']?.showMarketingText && (
                        <div className="fifth-page margin-top20">
                            <div className="slds-p-around_small">
                                <tds-input type="checkbox" id="Privacy_Consent__c" label={inputValues['termsAndCondition']?.marketingText} />
                            </div>
                        </div>
                    )}

                    {inputValues['Country__c'] &&
                        <div className="slds-p-around_small">
                            <p className="receiving-msg">
                                By agreeing to receive messages you will get communications from the Tableau Academic Program with learning materials, invitations to events, and instructor resources to help implement Tableau in the classroom.
                            </p>
                        </div>
                    }

                    {inputValues['termsAndCondition']?.legalText && (
                        <div className="sixth-page slds-p-around_small">
                            {inputValues['termsAndCondition']?.showLegalCheckbox && (
                                <tds-input
                                    className={`display-inline`}
                                    type="checkbox"
                                    id="legalText"
                                    data-validate='legalCheckbox'
                                />
                            )}
                            <span
                                className='legal-txt'
                                dangerouslySetInnerHTML={{
                                    __html:
                                        inputValues['termsAndCondition']?.legalText
                                }}
                            />
                            {fieldErrors['legalText'] && (
                                <div className="legal-txt-error">{fieldErrors['legalText']}</div>
                            )}
                            {inputValues['termsAndCondition']?.learnMore && (
                                <p
                                    className="learn-more-txt"
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            inputValues['termsAndCondition']?.learnMore
                                    }} />
                            )}
                        </div>
                    )}

                    <div>
                        <div className="sixth-page slds-p-around_small slds-align_absolute-center">
                            <ReCAPTCHA
                                ref={recaptchaRefFormHandler}
                                sitekey={process.env.GATSBY_TBC_RECAPTCHA_SITE_KEY}
                                onChange={handleRecaptchaFormHandler}
                                onExpired={handleRecaptchaFailFormHandler}
                                onErrored={handleRecaptchaFailFormHandler} />

                        </div>
                        {fieldErrors['recaptcha-widget'] &&
                            <div class="slds-align_absolute-center slds-p-around_small input-error" id="recaptcha-error">{fieldErrors['recaptcha-widget']} </div>
                        }

                        {fieldErrors['previewErrors'] && (
                            <div class="slds-align_absolute-center slds-p-around_small input-error">
                                {fieldErrors['previewErrors']}
                            </div>
                        )}

                        <div className="slds-align_absolute-center slds-p-around_small">
                            <tds-button variant="brand" onClick={handleSubmitForm}>ACCEPT AND SUBMIT</tds-button>
                        </div>
                    </div>

                    {showModal && (<div className='modal'>
                        <div className="modal-content">
                            <div className="success-msg">
                                {!isLoading && (
                                    <p><span className='close-icon' onClick={(e) => clearFormDetails(e)}>X</span></p>
                                )}
                                <div className="confirmation-box">
                                    {isLoading && (
                                        <p>Loading...</p>
                                    )}
                                    {apiMessage?.status === 'success' ? (
                                        <p>Thank you for your request; your submission has been recorded and you will receive a copy of your responses via email.<br />
                                            Our team will be in contact within 3-5 business days. If you have any questions, please email the Tableau Academic Program team at <u>tft@tableau.com</u></p>
                                    ) : (!isLoading &&
                                        <p className='error-txt'>There has been an error in processing your request, and your request was not submitted. Please reach out to <u>tft@tableau.com</u> regarding this error.</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    )}

                    <div className="footer slds-p-around_small">
                        <b>Additional Terms and Conditions:</b> The licenses provided through Tableau’s Academic Programs shall be used only for Instructional Use or Noncommercial Academic Research. “Instructional Use” means evaluating Tableau for classroom use, developing materials and familiarity in Tableau for classes, and academic instruction. “Noncommercial Academic Research” means conducting not-for-profit research projects, which are not intended to or in fact produce results, works, services, or data for commercial use by anyone or to generate revenue. By submitting this form, you agree that any Tableau Academic Program licenses provided through Tableau’s Academic Programs will only be used for these purposes. You also agree that any student licenses issued will only be provided to students enrolled in the class specified above, and not to any other students, faculty, staff or other personnel.<br />
                        Lab Licenses may be used for educational use in computer labs in which only students and teaching faculty have access. Lab Licenses may not be used for commercial purposes, including, but not limited to, administrative use, consulting, commercial research, institutional research or other non-educational use. For purposes of Lab Licenses, Authorized Users do not need to be uniquely identified.
                        By clicking "Accept and Submit" above, you (1) certify all of the foregoing information is true and correct, and (2) agree to the terms of the Tableau Software End User License Agreement (tableau.com/eula), as modified by the Additional Terms and Conditions set forth above.
                    </div>

                </div>
            )}
        </LWCLayout>
    )
}

export default TableauTemplate
